import { call, put, takeLeading, takeLatest } from "redux-saga/effects";
import { processErrors } from "../../../util/helpers";
import {
    createSubscription as createSubscriptionApi,
    upgradeSubscription as upgradeSubscriptionApi,
    fetchSubscriptions as fetchSubscriptionsApi,
    createPortalSession as createPortalSessionApi,
} from "./api";
import {
    createSubscription,
    createSubscriptionSuccess,
    createSubscriptionFailed,
    upgradeSubscription,
    upgradeSubscriptionSuccess,
    upgradeSubscriptionFailed,
    fetchSubscriptions,
    fetchSubscriptionsSuccess,
    fetchSubscriptionsFailed,
    createPortalSession,
    createPortalSessionSuccess,
    createPortalSessionFailed,
} from "./slice";

export function* newSubscription(actions) {
    try {
        const { id, data } = actions?.payload;
        const response = yield call(createSubscriptionApi, id, { ...data });
        const resp = response && response.data;

        yield put(createSubscriptionSuccess(resp));
    } catch (e) {
        const message =
            processErrors(e?.response?.data) ||
            "Failed to create new subscription";
        yield put(createSubscriptionFailed(message));
    }
}

export function* updateSubscription(actions) {
    try {
        const { id, data } = actions?.payload;
        const response = yield call(upgradeSubscriptionApi, id, { ...data });
        const resp = response && response.data;

        yield put(upgradeSubscriptionSuccess(resp));
    } catch (e) {
        const message =
            processErrors(e?.response?.data) ||
            "Failed to upgrade subscription";
        yield put(upgradeSubscriptionFailed(message));
    }
}

export function* getSubscriptions(actions) {
    try {
        const { customer_id } = actions.payload;
        const response = yield call(fetchSubscriptionsApi, customer_id);
        const resp = response && response.data;

        yield put(fetchSubscriptionsSuccess(resp));
    } catch (e) {
        const message =
            processErrors(e?.response?.data) || "Failed to get subscriptions";
        yield put(fetchSubscriptionsFailed(message));
    }
}

export function* addPortalSession(actions) {
    try {
        const { customer_id, workspace_id } = actions.payload;
        const response = yield call(
            createPortalSessionApi,
            customer_id,
            workspace_id,
        );
        const resp = response && response.data;

        yield put(createPortalSessionSuccess(resp));
    } catch (e) {
        const message =
            processErrors(e?.response?.data) || "Failed to get portal session";
        yield put(createPortalSessionFailed(message));
    }
}

export function* watchCreateSubscription() {
    yield takeLeading(createSubscription.type, newSubscription);
}

export function* watchUpgradeSubscription() {
    yield takeLeading(upgradeSubscription.type, updateSubscription);
}

export function* watchFetchSubscriptions() {
    yield takeLatest(fetchSubscriptions.type, getSubscriptions);
}

export function* watchCreatePortalSession() {
    yield takeLatest(createPortalSession.type, addPortalSession);
}
